import { render, staticRenderFns } from "./ServiceListSkeleton.vue?vue&type=template&id=61df7fe2&scoped=true"
import script from "./ServiceListSkeleton.vue?vue&type=script&lang=ts"
export * from "./ServiceListSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ServiceListSkeleton.vue?vue&type=style&index=0&id=61df7fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61df7fe2",
  null
  
)

export default component.exports